import { render, staticRenderFns } from "./BankConfig.vue?vue&type=template&id=685844de&scoped=true"
import script from "./BankConfig.vue?vue&type=script&lang=js"
export * from "./BankConfig.vue?vue&type=script&lang=js"
import style0 from "./BankConfig.vue?vue&type=style&index=0&id=685844de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685844de",
  null
  
)

export default component.exports